import { CardActions, CardContent, Stack, Typography, type TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { SurfacePanel } from './SurfacePanel';

interface EntityCardProps {
  title: ReactNode;
  description?: ReactNode;
  meta?: ReactNode;
  footer?: ReactNode;
}

const ContentStack = styled(Stack)({
  position: 'relative',
  zIndex: 1,
});

const ClampedDescription = styled(Typography)<TypographyProps>({
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

const FooterActions = styled(CardActions)({
  position: 'relative',
  zIndex: 1,
});

const CardShell = styled(SurfacePanel)({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
});

const BodyContent = styled(CardContent)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  flex: 1,
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2.25),
  },
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  color: theme.vars?.palette.text.primary ?? theme.palette.text.primary,
  fontWeight: 700,
}));

export function EntityCard({ title, description, meta, footer }: EntityCardProps) {
  return (
    <CardShell>
      <BodyContent>
        <ContentStack spacing={1}>
          <CardTitle variant="subtitle1">{title}</CardTitle>
          {description ? (
            <ClampedDescription variant="body2" color="text.secondary">
              {description}
            </ClampedDescription>
          ) : null}
          {meta}
        </ContentStack>
      </BodyContent>
      {footer ? <FooterActions>{footer}</FooterActions> : null}
    </CardShell>
  );
}
